// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__3UNdv","loading":"Loading_loading__7c8l6"};